import { useLayoutEffect, useRef, useState } from 'react';
import { cn } from '@shared/lib/utils';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

interface TruncatedTextProps {
  value: string;
  className?: string;
  tooltipClassName?: string;
}

export function TruncatedText({ value, className, tooltipClassName }: TruncatedTextProps) {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const check = () => {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    };

    check();

    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [value]);

  const textClassName = cn('block min-w-0 truncate', className, isTruncated && 'cursor-default');

  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip open={isTruncated ? undefined : false}>
        <TooltipTrigger asChild>
          <span ref={textRef} className={textClassName} title={isTruncated ? value : undefined}>
            {value}
          </span>
        </TooltipTrigger>
        {isTruncated ? (
          <TooltipContent className={cn('max-w-sm break-all', tooltipClassName)} side="top">
            {value}
          </TooltipContent>
        ) : null}
      </Tooltip>
    </TooltipProvider>
  );
}
